export const ACCEPT_TERMS_POLICE = 'ATP'
